import React from 'react';
import { Golf, Stack, Sword, Clock, Trophy, UsersThree } from '@phosphor-icons/react';
import './EventTypeSelector.css';

// Descriptions are written to occupy two lines on a phone: enough room to say
// what you can actually DO from each card, without a third line, which would
// grow every card and push the last option below the fold. Roughly 42-72
// characters lands on two lines from 320px up — see EventTypeSelector.css.
// Exported so a caller can open the wizard straight onto one of these — Play
// Golf's "New Roll Up" is this list's `roll_up` entry, and its defaults have to
// be the same ones the selector would have applied.
export const EVENT_TYPES = [
    {
        key: 'single_round',
        icon: Golf,
        title: 'Quick Round',
        description: 'One course, one round — pick players and start scoring.',
        colorClass: 'event-card--blue',
        defaults: { format: 'Stableford', matchplay_percentage: 95, signup_mode: 'standard' },
        quickMode: true,
    },
    {
        // Named for the depth of setup, not the round count: this is the
        // full-featured path and handles a single round perfectly well, which
        // "Multi Round" actively hid. The description keeps the old wording so
        // anyone hunting for it still lands here.
        key: 'multi_round',
        icon: Stack,
        title: 'Competition',
        description: 'Single or multi round, with tee sheets and shotgun starts.',
        colorClass: 'event-card--indigo',
        defaults: { format: 'Stableford', matchplay_percentage: 95, signup_mode: 'standard' },
    },
    {
        // Singles vs pairs is chosen on the Scoring step, not here.
        key: 'matchplay',
        icon: Sword,
        title: 'Matchplay',
        description: 'Head to head singles or pairs, scored hole by hole.',
        colorClass: 'event-card--emerald',
        defaults: { format: 'Singles Matchplay', matchplay_percentage: 100, signup_mode: 'standard' },
    },
    {
        key: 'roll_up',
        icon: Clock,
        title: 'Roll Up',
        description: 'Publish an open tee sheet and let players claim their own slots.',
        colorClass: 'event-card--violet',
        defaults: { format: 'Stableford', matchplay_percentage: 95, signup_mode: 'roll_up' },
    },
    {
        key: 'team_games',
        icon: UsersThree,
        title: 'Team Games',
        description: 'One ball per team — Foursomes, Greensomes or Texas Scramble.',
        colorClass: 'event-card--teal',
        route: '/tournaments/add-advanced?group=team',
    },
    {
        key: 'advanced',
        icon: Trophy,
        title: 'Advanced Formats',
        description: 'Society team events, side games and build-your-own scoring.',
        colorClass: 'event-card--gold',
        route: '/tournaments/add-advanced',
    },
];

const EventTypeSelector = ({ onSelect }) => {
    return (
        <div className="event-type-selector">
            <p className="event-type-selector__subtitle">What kind of competition are you setting up?</p>
            <div className="event-type-selector__list">
                {EVENT_TYPES.map((type) => {
                    const Icon = type.icon;
                    return (
                        <button
                            key={type.key}
                            className={`event-card ${type.colorClass}`}
                            onClick={() => onSelect(type)}
                        >
                            <div className="event-card__icon-wrapper">
                                <Icon size={22} weight="duotone" />
                            </div>
                            <div className="event-card__text">
                                <span className="event-card__title">{type.title}</span>
                                <span className="event-card__description">{type.description}</span>
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default EventTypeSelector;
